import Vue from 'vue';

export async function downloadAboutUs({ commit }) {
  commit('cleanErrors');
  await Vue.axios({
    method: 'GET',
    url: `/configuration/about_us/`,
  }).then((response) => {
    commit('saveAboutUs', response.data.about_us);
  });
}

export async function fetchTodayStars({ commit }, data) {
  await Vue.axios({
    method: 'GET',
    url: `/child/${data.childId}/stars_today/${data.date ? `?date=${data.date}` : ''}`,
  })
    .then((response) => {
      commit('saveChildStars', response.data);
    })
    .catch((error) => {
      commit('error', error.message);
    });
}

export async function fetchCriterionDescription({ commit }) {
  await Vue.axios({
    method: 'GET',
    url: `/criterion/get_description/`,
  })
    .then((response) => {
      commit('saveCriterionDescription', response.data.challenge_description);
    })
    .catch((error) => {
      commit('error', error.message);
    });
}

export async function setSession({ commit }, data) {
  await Vue.axios({
    method: 'POST',
    url: `/session/`,
    data: {
      route: data.route,
      device: data.device,
      user: data.userId,
    },
  })
    .then(() => {
      commit('cleanErrors');
    })
    .catch((error) => {
      commit('error', error);
    });
}

export async function fetchAvatarImages({ commit }) {
  await Vue.axios({
    method: 'GET',
    url: `/profile_avatar/`,
  })
    .then((response) => {
      console.log('saveAvatarImages', response.data);
      commit('saveAvatarImages', response.data);
    })
    .catch((error) => {
      commit('error', error);
    });
}

export async function fetchFaqsPost({ commit }, { query }) {
  try {
    const { keywords = '', topic_id = '' } = query;
    const { data: faqs } = await Vue.axios({
      method: 'GET',
      url: '/faq/',
      params: {
        keywords,
        topic_id,
      },
    });
    commit('setFaqsPost', faqs);
  } catch (error) {
    commit('error', error);
    throw new Error('[FAQS]: Problems at time to fetch...');
  }
}

export async function fetchFaqsTopics({ commit }) {
  try {
    const { data: topics } = await Vue.axios({
      method: 'GET',
      url: '/faq/topics/',
    });
    commit('setFaqsTopics', topics);
  } catch (error) {
    commit('error', error);
    throw new Error('[FAQS | TOPICS]: Problems at time to fetch...');
  }
}
